import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | paid | timeout | error
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setState("error"); return; }

    let timer;
    const poll = async () => {
      if (attempts.current >= 8) { setState("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("error"); return; }
      } catch { /* keep polling */ }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-6 text-center" data-testid="payment-success-page">
      {state === "checking" && (
        <>
          <Loader2 className="h-12 w-12 animate-spin text-primary" />
          <p className="mt-4 font-head text-xl font-bold text-secondary">Confirmando tu pago…</p>
        </>
      )}
      {state === "paid" && (
        <>
          <CheckCircle2 className="h-16 w-16 text-accent" />
          <h1 className="mt-4 font-head text-3xl font-extrabold text-secondary">¡Suscripción activada!</h1>
          <p className="mt-2 text-slate-600">Tu negocio ya está publicado en el directorio.</p>
          <Button onClick={() => navigate("/dashboard")} className="mt-6 rounded-sm bg-primary hover:bg-orange-600" data-testid="success-go-dashboard">Ir al panel</Button>
        </>
      )}
      {(state === "timeout" || state === "error") && (
        <>
          <XCircle className="h-16 w-16 text-slate-400" />
          <h1 className="mt-4 font-head text-2xl font-extrabold text-secondary">{state === "timeout" ? "El pago sigue procesándose" : "No pudimos confirmar el pago"}</h1>
          <p className="mt-2 text-slate-600">{state === "timeout" ? "Puede tardar un momento. Revisa tu panel en unos minutos." : "Si se te cobró, se activará automáticamente."}</p>
          <Button onClick={() => navigate("/dashboard/subscription")} variant="outline" className="mt-6 rounded-sm" data-testid="success-back-sub">Volver a Suscripción</Button>
        </>
      )}
    </div>
  );
}
